module.exports = __webpack_public_path__ + "img/TREC Final Logo.9aaf75cf.jpg";